module.exports = __webpack_public_path__ + "img/dark-arrow-left.5c77fc8a.svg";